import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MockFiService {
  // User-configured FI target
  getUserSettings(): Observable<{ fiTarget: number }> {
    return of({ fiTarget: 1000000 });
  }

  // Current snapshot: current savings and average monthly savings
  getCurrentSnapshot(): Observable<{ currentSavings: number; monthlyAvgSavings: number; snapshots: number[] }> {
    return of({ currentSavings: 200000, monthlyAvgSavings: 1500, snapshots: [1200, 1300, 1500] });
  }

  // Last N months of savings (very small sample for the mini-chart)
  getLastMonthsSavings(months = 3): Observable<number[]> {
    const data = [1200, 1300, 1500].slice(-months);
    if (environment && environment.authApiUrl) {
      // eslint-disable-next-line no-console
      console.debug('MockFiService using apiBaseUrl:', environment.authApiUrl);
    }
    return of(data);
  }
}
